import React, { useContext, useEffect, useMemo } from "react";
import CustomBreadcrumb from "../../common/CustomBreadcrumb";
import CommonTable from "../../common/CommonTable";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ThemeContext } from "../../common/themeContext";
import Loader from "../Loder/loader";
import { Switch, message } from "antd";
import moment from "moment";
import {
    getTermsAndConditionsListAction,
    getTermsAndConditionsListHandler,
} from "../../redux/action/getTermsAndConditionsListSlice";
import {
    updateTermsAndConditionsStatusAction,
    updateTermsAndConditionsStatusHandler,
} from "../../redux/action/updateTermsAndConditionsStatusSlice";

const TermsAndCondition = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { brandId } = useContext(ThemeContext);

    const termsListState = useSelector((state) => state?.getTermsAndConditionsList);
    const updateStatusState = useSelector(
        (state) => state?.updateTermsAndConditionsStatus,
    );

    const listPayload = useMemo(() => {
        if (!brandId) return;
        return {
            refBrandId: brandId ,
            search: "",
            limit: 10,
            offSet: 1,
            sortBy: "id",
            sortDirection: "desc",
        };
    }, [brandId]);

    useEffect(() => {
        if (!brandId) return;
        dispatch(getTermsAndConditionsListHandler(listPayload));
    }, [brandId, dispatch, listPayload]);

    useEffect(() => {
        if (!termsListState) return;
        if (termsListState?.error) {
            message.error(termsListState.error);
            dispatch(getTermsAndConditionsListAction.getTermsAndConditionsListInfoReset());
        }
    }, [dispatch, termsListState]);

    useEffect(() => {
        if (!updateStatusState) return;
        if (updateStatusState?.message) {
            message.success(updateStatusState.message);
            dispatch(
                updateTermsAndConditionsStatusAction.updateTermsAndConditionsStatusInfoReset(),
            );
            dispatch(getTermsAndConditionsListHandler(listPayload));
        }
        if (updateStatusState?.error) {
            message.error(updateStatusState.error);
            dispatch(
                updateTermsAndConditionsStatusAction.updateTermsAndConditionsStatusInfoReset(),
            );
        }
    }, [dispatch, listPayload, updateStatusState]);

    const rows = useMemo(() => {
        const items = Array.isArray(termsListState?.data?.data)
            ? termsListState.data.data
            : Array.isArray(termsListState?.data)
                ? termsListState.data
                : [];

        return items.map((item) => ({
            key: item?.id,
            id: item?.id,
            documentName: item?.documentName ?? "Terms & Conditions",
            lastUpdated: item?.modifiedAt
                ? moment(item.modifiedAt).format("YYYY-MM-DD")
                : "",
            version: item?.version ?? "",
            status: String(item?.activeStatus || "").toUpperCase() === "ACTIVE",
        }));
    }, [termsListState?.data]);

    const columns = [
        {
            title: "Document Name",
            dataIndex: "documentName",
            key: "documentName",
        },
        {
            title: "Last updated",
            dataIndex: "lastUpdated",
            key: "lastUpdated",
        },
        {
            title: "Version",
            dataIndex: "version",
            key: "version",
        },
        // {
        //     title: "Status",
        //     dataIndex: "status",
        //     key: "status",
        //     render: (_, row) => (
        //         <Switch
        //             checked={row.status}
        //             loading={
        //                 updateStatusState?.isLoading === true &&
        //                 updateStatusState?.updatingId === row?.id
        //             }
        //             disabled={
        //                 updateStatusState?.isLoading === true &&
        //                 updateStatusState?.updatingId === row?.id
        //             }
        //             onChange={(checked) => {
        //                 const nextStatus = checked ? "ACTIVE" : "INACTIVE";
        //                 dispatch(
        //                     updateTermsAndConditionsStatusHandler({
        //                         refBrandId: brandId ,
        //                         status: nextStatus,
		// 						termsConditionId: row?.id,
        //                     }),
        //                 );
        //             }}
        //         />
        //     ),
        // },
        {
            title: "Action",
            key: "action",
            render: (_, row) => (
                <button
                    className="manage"
                    type="button"
                    onClick={() =>
                        navigate(`/ai-campaigns/terms-conditions/manage`, {
                            state: {
                                documentName: row?.documentName,
                                termsConditionId: row?.id,
                            },
                        })
                    }
                >
                    Manage
                </button>
            ),
        },
    ];

    return (
        <div className="rightside">
            <div className="rightcontent">
                <p>
                    <strong>Terms & Conditions</strong>
                </p>
                <CustomBreadcrumb
                    items={[
                        { text: "Home" },
                        { text: "AI Campaigns" },
                        { text: "Terms & Conditions", active: true },
                    ]}
                />

                <div className="table-padding">
                    <div className="headtitle">
                        <p className="mb-0 heedprodct">Terms & Conditions</p>
                    </div>
                    <hr className="m-0" />
                    <div className="table-responsive">
                        {(termsListState?.isLoading === true ||
                            updateStatusState?.isLoading === true) && (
                            <Loader loaderTransform="loaderTransform" />
                        )}
                        <CommonTable
                            handlePageChange={() => { }}
                            pagination={{}}
                            body={rows}
                            columns={columns}
                            isPagination={false}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TermsAndCondition;